var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketExtremeBigMoveUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.43 5.556l7.304 7.305a1.76 1.76 0 010 2.568 1.76 1.76 0 01-2.568 0L14 11.263v21.115c0 1.027-.856 1.826-1.826 1.826a1.803 1.803 0 01-1.827-1.826V11.263L6.124 15.43a1.76 1.76 0 01-2.568 0 1.76 1.76 0 010-2.568l7.305-7.305a1.76 1.76 0 012.568 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.266 27.372l7.305 7.305a1.76 1.76 0 002.568 0l7.305-7.305a1.76 1.76 0 000-2.567 1.76 1.76 0 00-2.568 0l-4.223 4.165v-3.636H26v3.636l-4.166-4.165a1.76 1.76 0 00-2.568 0 1.76 1.76 0 000 2.567zM26 22.204h3.653v-3.13H26v3.13zm0-6.261h3.653v-3.13H26v3.13zm0-6.261V7.855c0-1.027.856-1.826 1.826-1.826 1.028 0 1.827.8 1.827 1.826v1.827H26z"
  })));
}
export default SvgMarketExtremeBigMoveUp;